<form autocomplete="off" [formGroup]="bankDetailsForm">
    <div class="row">
        <div class="col-md-2">
            <div class="mb-2">
                <label for="bankname" class="form-label">Bank Name</label>
                <input type="text" class="form-control form-control-sm" id="bankname" formControlName="txtBankName" maxlength="80"  >
            </div>
        </div>
        <div class="col-md-3">
            <div class="mb-2">
                <label for="accountno" class="form-label">Account No.</label>
                <input type="text" class="form-control form-control-sm" id="accountno" formControlName="txtAccountNo"
                    [ngClass]="{'is-invalid': (bankDetailsForm.get('txtAccountNo').touched) && bankDetailsForm.get('txtAccountNo').errors}"  >
                <div *ngIf="(bankDetailsForm.get('txtAccountNo').touched) && bankDetailsForm.get('txtAccountNo').errors" class="invalid-feedback">
                    <span *ngIf="bankDetailsForm.get('txtAccountNo').errors.pattern">Mininum 5 and Maximum 20 characters allowed</span>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="mb-2">
                <label for="accountname" class="form-label">Account Name</label>
                <input type="text" class="form-control form-control-sm" id="accountname"
                    formControlName="txtAccountName" maxlength="50"  >
            </div>
        </div>
        <div class="col-md-2">
            <div class="mb-2">
                <label for="ifsc" class="form-label">IFSC Code</label>
                <input type="text" class="form-control form-control-sm" id="ifsc" formControlName="txtIfscCode" maxlength="15" 
                [ngClass]="{'is-invalid': (bankDetailsForm.get('txtIfscCode').touched) && bankDetailsForm.get('txtIfscCode').errors}"  >
                <div *ngIf="(bankDetailsForm.get('txtIfscCode').touched) && bankDetailsForm.get('txtIfscCode').errors" class="invalid-feedback">
                    <span *ngIf="bankDetailsForm.get('txtIfscCode').errors.pattern">Only alphanumeric characters are allowed.</span>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="mb-2">
                <label for="micr" class="form-label">MICR</label>
                <input type="number" class="form-control form-control-sm" id="micr" formControlName="txtMicr" appLimitDigits [length] = "9"
                [ngClass]="{'is-invalid': (bankDetailsForm.get('txtMicr').touched) && bankDetailsForm.get('txtMicr').errors}"  >
                <div *ngIf="(bankDetailsForm.get('txtMicr').touched) && bankDetailsForm.get('txtMicr').errors" class="invalid-feedback">
                    <span *ngIf="bankDetailsForm.get('txtMicr').errors.pattern">Must be of 9 Digits.</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="mb-2">
                <label for="bankaddress" class="form-label">Bank Address</label>
                <input type="text" class="form-control form-control-sm" id="bankaddress" maxlength="150" formControlName="txtBankAddress"  >
            </div>
        </div>
        <!-- Conditionally render the firm dropdown -->
        <!-- <div class="col-md-4" *ngIf="hasControl('ddlFirm')">
            <div class="mb-2">
            <label for="firm" class="form-label">Firm</label>
            <ng-select
                placeholder="Select"
                [appendTo]="'body'" [openOnEnter]="false"
                formControlName="ddlFirm"
                [items]="firmList"
                bindLabel="name"
                [bindValue]="'name'"
                appEnterDirective
                [onEnterKey]="useEnterKey">
            </ng-select>
            </div>
        </div> -->
    </div>
    <!-- <div class="row">
        <div class="col-md-4" *ngIf="hasControl('nfeiCheck')">
            <div class="mb-2">
                <label for="nfei" class="form-label">NFEI</label>
                <div class="form-check form-switch form-switch-md">
                    <input type="checkbox" class="form-check-input" formControlName="nfeiCheck" >
                </div>
            </div>
        </div>
    </div> -->
</form>